import {defineAbilityConfig} from '../system/defineAbilityConfig';
import {DESIGNER_SITE_MODES} from '@packages/systems/design-system/constants/DesignerUI';
import {ONLY_ON_PRIMARY_LOCALE} from './localization';

/**
 * Determines whether the user can access Code Mode (App Gen).
 *
 * Requires full Designer role permissions (design access on both siteDesignerModes and site resources).
 * This specifically excludes Editor role users who only have edit mode access.
 * Also requires Code Mode feature flag, AI/Copilot enabled, and leader role in multiplayer.
 */
export const canAccessCodeMode = defineAbilityConfig({
  userTypes: {
    authorizedInDesigner: true,
  },
  permissions: [
    [DESIGNER_SITE_MODES.DESIGN, 'siteDesignerModes'],
    [DESIGNER_SITE_MODES.DESIGN, 'site'],
  ],
  siteModes: {design: true},
  abilities: {canAccessAIFeatures: true},
} as const);

/**
 * This ability is used to determine whether or not the user can access the Code Mode Navigation Panel.
 */
export const canAccessCodeModeNavigationPanel = defineAbilityConfig({
  workflows: {webApps: true},
} as const);

export const canAccessOrionAppsListPanel = defineAbilityConfig({
  workflows: {webApps: true},
} as const);

export const canEditCodeComponents = defineAbilityConfig({
  userTypes: {
    authorizedInDesigner: true,
  },
  siteKinds: {
    webflow: true,
    tutorial: true,
    cloudapp: true,
    optimize: true,
    campaign: false,
  },
  abilities: {
    canAccessDesignSiteMode: true,
    canAccessAIFeatures: true,
  },
  // Code components are structural; editing is only allowed in the primary
  // locale. Secondary locales can localize props/styles but not edit the
  // component source (CODE-3890).
  localization: ONLY_ON_PRIMARY_LOCALE,
  // Code components are global to the project, so editing them on a page
  // branch would mutate the shared component across the whole project.
  // Only allow editing on main (CODE-3501).
  branches: {main: true},
});
